<ng-container *ngIf="
    additionalInformation.LineTemplate != null &&
    additionalInformation.LineTemplate !== '' &&
    !(
      screenSize === 'large' ||
      screenSize === 'medium' ||
      screenSize === 'x-large'
    )
  ">
  <ng-container *ngIf="this.screenSize === 'small' || this.screenSize === 'x-small'">
    <nz-row nzGutter="20">
      <app-cards [actionType]="actionType" [quantityField]="quantityField" [countedField]="countedField"
        [recordModel]="recordModel" [enablePaginationInLineSection]="enablePaginationInLineSection"
        [pageSizeInLineSection]="pageSizeInLineSection" [lines]="sectionLines" [section]="section"
        [itemCodeField]="itemCodeField" [moduleStructure]="moduleStructure" [fieldGroupKeys]="fieldGroupKeys"
        [fieldGroups]="fieldGroups" (deleteRowEmitter)="deleteRow($event)" (editRowEmitter)="editRow($event, true)"
        (getPullValEmitter)="getPullVal($event)" (getPushValEmitter)="getPushVal($event)"
        (getSpanValEmitter)="getSpanVal($event)"></app-cards>
    </nz-row>
  </ng-container>
</ng-container>
<ng-container *ngIf="
    additionalInformation.LineTemplate == null ||
    additionalInformation.LineTemplate === '' ||
    !!(
      screenSize === 'large' ||
      screenSize === 'medium' ||
      screenSize === 'x-large'
    )
  ">

  <app-custom-buttons *ngIf="section != null && !fromLog" [moduleStructure]="moduleStructure"
    [recordModel]="recordModel" [recordPage]="parentComponent" [forSection]="true" [renderBeforeContent]="true"
    [sectionId]="section.Id">
  </app-custom-buttons>

  <nz-table #sectionTable [nzBordered]="true" [nzFrontPagination]="enablePaginationInLineSection"
    [(nzPageIndex)]="currentPage" [nzPageSize]="pageSizeInLineSection" [nzSize]="'large'" [nzData]="sectionLines"
    [nzScroll]="{ x: tableWidth + 50 + 'px' , y: scrollY}" [nzLoading]="loading || bomLoading">
    <thead>
      <tr>
        <th nzWidth="36px" nzLeft>#</th>
        <th nzWidth="36px" nzLeft
          *ngIf="recordModel.EventType !== 3 && section.AdditionalInformationParsed.AllowSelectLines"></th>
        <th nzWidth="36px" nzLeft
          *ngIf="recordModel.EventType !== 3 && section.AdditionalInformationParsed.ActionAtTheBegning"></th>
        <th nzWidth="10px" nzLeft *ngIf="recordModel.EventType !== 3 && deleteIsOutOfActions"></th>
        <th nzWidth="36px" nzLeft
          *ngIf="section != null && displayActionForLine && section.AdditionalInformationParsed.CustomButtonsAtTheBegning">
        </th>
        <th *ngFor="let field of fieldsToRender; let i = index" [nzWidth]="
            field.AdditionalInformationParsed.Width === 0
            ? '140px'
            : field.AdditionalInformationParsed.Width + 'px'
            " style="text-align: center" [nzRight]="field.AdditionalInformationParsed.FixedInTableType == 2"
          [nzLeft]="field.AdditionalInformationParsed.FixedInTableType == 1">
          {{ field.Label | locale }}
        </th>
        <th
          [nzWidth]="(section.AdditionalInformationParsed.CustomActionColumnWidth === 0 ? '250' : section.AdditionalInformationParsed.CustomActionColumnWidth) +'px'"
          *ngIf="section != null && displayActionForLine && !section.AdditionalInformationParsed.CustomButtonsAtTheBegning">
          {{'Actions' | locale}}
        </th>
        <th nzWidth="60px" nzRight
          *ngIf="recordModel.EventType !== 3 && !section.AdditionalInformationParsed.ActionAtTheBegning">Actions</th>
      </tr>
    </thead>
    <tbody (dblclick)="handleTableClick()">
      <ng-container *ngFor="let data of sectionTable.data; let j = index">
        <ng-container *ngIf="
            data.Visible || data.Visible === undefined || data.Visible === null
          ">
          <tr [ngClass]="{ 'subtotal-row': data.LineType === 'S' }" [class]="data.CssClass">
            <td style="min-width: 50px" nzLeft class="row-index">
              {{ j + 1 }}
              <!-- <button (click)="addLineBefore(j)">add line</button> -->
            </td>
            <!-- <td nzLeft style="min-width: 50px"
              *ngIf="recordModel.EventType !== 3 && section.AdditionalInformationParsed.AllowSelectLines"
              [nzDisabled]="!(((data.BaseItemCodeProp !== undefined &&
              data.TreeTypeProp.ValueAsObject !== 'I' &&
              data.TreeTypeProp.ValueAsObject !== 'iIngredient' ) ||
            data.TreeTypeProp == undefined ||
            data.TreeTypeProp.ValueAsObject == 'N' ||
            data.TreeTypeProp.ValueAsObject == 'iNotATree'
          ))" [nzChecked]="setOfCheckedId.has(data.Id)" (nzCheckedChange)="onItemChecked(data.Id, j, $event)">
            </td> -->

            <td nzLeft style="min-width: 50px"
              *ngIf="recordModel.EventType !== 3 && section.AdditionalInformationParsed.AllowSelectLines"
              [nzChecked]="setOfCheckedId.has(data.Id)" (nzCheckedChange)="onItemChecked(data.Id, j, $event)">
            </td>
            <td class="actions-cell" nzLeft
              *ngIf="recordModel.EventType !== 3 && section.AdditionalInformationParsed.ActionAtTheBegning">
              <app-line-section-actions *ngIf="
                  data.ItemCodeProp === undefined ||
                  (data.BaseItemCodeProp !== undefined &&
                    data.TreeTypeProp.ValueAsObject !== 'I' &&
                    data.TreeTypeProp.ValueAsObject !== 'iIngredient') ||
                  data.TreeTypeProp == undefined ||
                  data.TreeTypeProp.ValueAsObject == 'N' ||
                  data.TreeTypeProp.ValueAsObject == 'iNotATree'
                " [recordModel]="recordModel" [lines]="lines" [data]="data" [section]="section"
                (deleteRow)="deleteSectionRow(data)" (moveRowUp)="MoveRowUp(data,j)" (addRow)="addLineBefore(j)"
                (moveRowDown)="MoveRowDown(data,j)" (AddSubTotal)="AddNewSubTotalRow($event)"
                (AddTextLine)="addTextLineToTable($event)" (DuplicateLine)="DuplicateLine($event)"
                (PredefinedText)="PredefinedTextDrawer($event)">
              </app-line-section-actions>
            </td>
            <td nzWidth="10px" nzLeft *ngIf="recordModel.EventType !== 3 && deleteIsOutOfActions">
              <button nz-button nzType="default" nzDanger (click)="deleteConfirm(data)" style="border-radius: 5px">
                <i class="fal fa-trash"></i>
              </button>
            </td>
            <!-- <td nzLeft
              *ngIf="section != null && displayActionForLine && section.AdditionalInformationParsed.CustomButtonsAtTheBegning">
              <app-custom-buttons *ngIf="
              data.LineType !== 'S' &&
              data.LineType !== 'T' &&
              (
              data.ItemCodeProp === undefined ||
              (data.BaseItemCodeProp !== undefined &&
                data.TreeTypeProp.ValueAsObject !== 'I' &&
                data.TreeTypeProp.ValueAsObject !== 'iIngredient') ||
              data.TreeTypeProp == undefined ||
              data.TreeTypeProp.ValueAsObject == 'N' ||
              data.TreeTypeProp.ValueAsObject == 'iNotATree')
            " [moduleStructure]="moduleStructure" [recordModel]="recordModel" [recordPage]="parentComponent"
                [forSection]="true" [recordLine]="data" [sectionId]="section.Id">
              </app-custom-buttons>
            </td> -->
            <td nzLeft
              *ngIf="section != null && displayActionForLine && section.AdditionalInformationParsed.CustomButtonsAtTheBegning">
              <app-custom-buttons *ngIf="
              data.LineType !== 'S' &&
              data.LineType !== 'T' && !fromLog
            " [moduleStructure]="moduleStructure" [recordModel]="recordModel" [recordPage]="parentComponent"
                [forSection]="true" [recordLine]="data" [sectionId]="section.Id">
              </app-custom-buttons>
            </td>
            <ng-container *ngIf="
                data.LineType !== 'S' &&
                data.LineType !== 'T' &&
                (data
                  | MapValueFromObject
                    : 'Properties'
                    : true
                    : 'Name'
                    : 'ItemType'
                    : 'ValueAsObject') != -18
              ">
              <td app-field *ngFor="let field of fieldsToRender; let i = index" [lineId]="data.Id"
                [moduleStructure]="moduleStructure" [field]="field" [recordModel]="recordModel" [section]="section"
                [actionType]="actionType" [inTable]="false" [parentClass]="
                  (data.BaseItemCodeProp !== undefined &&
                    data.BaseItemCodeProp.ValueAsObject !== '' &&
                    (data.TreeTypeProp.ValueAsObject === 'I' ||
                      data.TreeTypeProp.ValueAsObject === 'iIngredient')) ?'childItem' : 'parentItem'
                " [ngClass]="{
                  childItem:
                    data.BaseItemCodeProp !== undefined &&
                    data.BaseItemCodeProp.ValueAsObject !== '' &&
                    (data.TreeTypeProp.ValueAsObject === 'I' ||
                      data.TreeTypeProp.ValueAsObject === 'iIngredient')
                }" [nzRight]="field.AdditionalInformationParsed.FixedInTableType == 2"
                [nzLeft]="field.AdditionalInformationParsed.FixedInTableType == 1" [recordCategory]="recordCategory"
                [recordLine]="data"></td>
            </ng-container>
            <ng-container *ngIf="data.LineType === 'S'">
              <td *ngFor="let field of fieldsToRender; let k = index"
                [nzRight]="field.AdditionalInformationParsed.FixedInTableType == 2"
                [nzLeft]="k === 0 || field.AdditionalInformationParsed.FixedInTableType == 1">
                <span *ngIf="k === 0">
                  {{ "Subtotal" | locale }}
                </span>
                <input *ngIf="field.PropertyName === 'LineTotal'" nz-input [ngModel]="data.LineText" readonly />
              </td>
            </ng-container>
            <ng-container *ngIf="data.LineType === 'T'">
              <td [colSpan]="fieldsToRender.length">
                <textarea *ngIf="!specialTextIsHTML" class="special-line-area" nz-input [nzAutosize]="{ minRows: 1 }"
                  [ngModel]="data.LineText | truncateHtml" (ngModelChange)="data.LineText = $event"
                  [rows]="data.LineText.split('\r').length" [readonly]="recordModel.EventType === 3"
                  (ngModelChange)="textLineChanged(data.Id,data.LineText)" [nzBorderless]="recordModel.EventType === 3"
                  style="padding: 5px">
                </textarea>

                <div *ngIf="recordModel.EventType !== 3 && specialTextIsHTML" [ngxSummernote]="config"
                  class="special-line-area" [ngxSummernoteView]="data.LineText" [(summernoteModel)]="data.LineText">
                </div>
                <div *ngIf="recordModel.EventType === 3 && specialTextIsHTML" [ngxSummernote]="config"
                  class="special-line-area" [ngxSummernoteView]="data.LineText" readonly disabled
                  [(summernoteModel)]="data.LineText"></div>

              </td>
            </ng-container>
            <ng-container *ngIf="
                data.Properties != null &&
                (data
                  | MapValueFromObject
                    : 'Properties'
                    : true
                    : 'Name'
                    : 'ItemType'
                    : 'ValueAsObject') === -18
              ">
              <td [colSpan]="fieldsToRender.length">
                <textarea nz-input [nzAutosize]="{ minRows: 1 }" [ngModel]="
                    data
                      | MapValueFromObject
                        : 'Properties'
                        : true
                        : 'Name'
                        : 'LineText'
                        : 'ValueAsObject'
                      | truncateHtml
                  " (ngModelChange)="POTextLineChanged($event, data)" [readonly]="recordModel.EventType === 3"
                  [nzBorderless]="recordModel.EventType === 3" style="padding: 5px">
                </textarea>
              </td>
            </ng-container>
            <!-- <td
              *ngIf="section != null && displayActionForLine && !section.AdditionalInformationParsed.CustomButtonsAtTheBegning">
              <app-custom-buttons *ngIf="
              data.LineType !== 'S' &&
              data.LineType !== 'T' &&
              (
              data.ItemCodeProp === undefined ||
              (data.BaseItemCodeProp !== undefined &&
                data.TreeTypeProp.ValueAsObject !== 'I' &&
                data.TreeTypeProp.ValueAsObject !== 'iIngredient') ||
              data.TreeTypeProp == undefined ||
              data.TreeTypeProp.ValueAsObject == 'N' ||
              data.TreeTypeProp.ValueAsObject == 'iNotATree')
            " [moduleStructure]="moduleStructure" [recordModel]="recordModel" [recordPage]="parentComponent"
                [forSection]="true" [recordLine]="data" [sectionId]="section.Id">
              </app-custom-buttons>
            </td> -->
            <td
              *ngIf="section != null && displayActionForLine && !section.AdditionalInformationParsed.CustomButtonsAtTheBegning">
              <app-custom-buttons *ngIf="
              data.LineType !== 'S' &&
              data.LineType !== 'T' && !fromLog
            " [moduleStructure]="moduleStructure" [recordModel]="recordModel" [recordPage]="parentComponent"
                [forSection]="true" [recordLine]="data" [sectionId]="section.Id">
              </app-custom-buttons>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </nz-table>
</ng-container>
<br />
<ng-container *ngIf="section.XmlTagName === 'Document_Lines' && enableItemImportation">
  <nz-form-item>
    <nz-form-control>
      <textarea nzAutosize nz-input placeholder="Paste item numbers and qty" style="width: 100%"
        [(ngModel)]="itemsToImport" [ngModelOptions]="{ standalone: true }"
        (keydown)="importItemsFromTextAreaHandleTab($event)"></textarea>
    </nz-form-control>
  </nz-form-item>
  <a nz-button (click)="importItemsFromTextArea();">
    {{'Import' | locale}}
  </a>
</ng-container>
<ng-container *ngIf="section.XmlTagName === 'Document_Lines' && enableItemFileImportation">
  <a nz-button (click)="importItemsFromFile();">
    {{'Import from file' | locale}}
  </a>
</ng-container>

<ng-container *ngIf="section.XmlTagName === 'BlanketAgreements_ItemsLines|BlanketAgreements_ItemsLine'">
  <a nz-button (click)="openCopyFromDrawer();">
    {{'Add more' | locale}}
  </a>
</ng-container>

<nz-button-group style="margin-top: 20px" class="button-containers">
  <button nz-button [nzShape]="'round'" (click)="addLineToTable()" *ngIf="
      section.AdditionalInformationParsed.AllowAdd &&
      (section.AdditionalInformationParsed.AllowAddInEditMode ||
        recordModel.EventType == 0) &&
      (actionType != 'View' || (actionType === 'View' && allowAddLineWnenClose))
    ">
    <i nz-icon nzType="plus" nzTheme="outline"></i> {{ "Add Row" | locale }}
  </button>
  <button *ngIf="
      (section.AdditionalInformationParsed.AllowSpecialLines &&
        !!(
          screenSize === 'large' ||
          screenSize === 'medium' ||
          screenSize === 'x-large'
        ) &&
        lineSection &&
        (section.AdditionalInformationParsed.AllowAddInEditMode ||
          recordModel.EventType == 0) &&
        actionType != 'View')
    " nz-button (click)="addTextLineToTable()">
    <i class="fal fa-text"></i> &nbsp;&nbsp;
    {{ "Add Text" | locale }}
  </button>
  <button *ngIf="
      section.AdditionalInformationParsed.AllowSpecialLines &&
      !!(
        screenSize === 'large' ||
        screenSize === 'medium' ||
        screenSize === 'x-large'
      ) &&
      lineSection &&
      (section.AdditionalInformationParsed.AllowAddInEditMode ||
        recordModel.EventType == 0) &&
      actionType != 'View' &&
      this.lines.length > 0
    " nz-button (click)="AddNewSubTotalRow()">
    <i class="fal fa-sigma"></i> &nbsp;&nbsp; {{ "Add Subtotal" | locale }}
  </button>
  <button nz-button (click)="addInterestedItem()" style="width: fit-content" *ngIf="
      parentRecordModel != undefined &&
      parentRecordModel.ObjectKey == 'oSalesOpportunities' &&
      recordModel.EventType == 0 &&
      actionType != 'View'
    ">
    <i nz-icon nzType="plus" nzTheme="outline"></i>
    {{ "Add Interested Item" | locale }}
  </button>

  <button nz-button *ngIf="setOfCheckedId.size > 0 && (recordModel.EventType === 0 || enableMovingLineInUpdateMode)"
    (click)="moveLinesUp()">
    {{'Move up' | locale }}
  </button>

  <button nz-button *ngIf="setOfCheckedId.size > 0 && (recordModel.EventType === 0 || enableMovingLineInUpdateMode)"
    (click)="moveLinesDown()">
    {{'Move down' | locale }}
  </button>

  <button nz-button *ngIf="setOfCheckedId.size > 0" (click)="DuplicateLines()">
    {{'Duplicate Lines' | locale }}
  </button>

  <button nz-button *ngIf="setOfCheckedId.size > 0 && allowBulkLineDelete" (click)="DeleteLines()">
    {{'Delete Lines' | locale }}
  </button>

  <app-custom-buttons *ngIf="section != null && !fromLog" [setOfCheckedId]="setOfCheckedId"
    [moduleStructure]="moduleStructure" [recordModel]="recordModel" [recordPage]="parentComponent" [forSection]="true"
    [renderBeforeContent]="false" [sectionId]="section.Id">
  </app-custom-buttons>
</nz-button-group>

<nz-modal [(nzVisible)]="listOfLinesVisible" nzTitle="Line after" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <nz-select [(ngModel)]="afterLineNum" [nzPlaceHolder]="'Select Line' | locale">
      <nz-option *ngFor="let line of linesList" [nzLabel]="line.Name" [nzValue]="line.LineNum">
      </nz-option>
    </nz-select>
  </ng-container>
</nz-modal>

<nz-drawer nzWrapClassName="confirmation-drawer" nzWrapClassName="drawer-size-4x"
  [nzVisible]="openDocumentRows.length > 0 && showCopyFromDrawer" [nzTitle]="'List of Open Rows' | locale"
  [nzFooter]="copyFromDrawerFooter" [nzClosable]="true" (nzOnClose)="showCopyFromDrawer = false">
  <form nz-form>
    <nz-tabset nzTabPosition="left">
      <nz-tab *ngFor="let documentSource of documentSources" [nzTitle]="
              '(' +
              minimizedOpenDocumentRowsForBA[documentSource.Id].length +
              ') ' +
              documentSource.Name
            " (nzSelect)="filteredData = openDocumentRows[documentSource.Id]">
        <form nz-form>
          <nz-table [nzData]="filteredData" #data [nzFrontPagination]="false">
            <thead>
              <tr>
                <th>
                  {{ "X" | locale }}
                </th>
                <th>
                  {{ "Document No." | locale }}
                  <input nz-input [(ngModel)]="filters.docNum" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                </th>
                <th>
                  {{ "Reference No." | locale }}
                  <input nz-input [(ngModel)]="filters.numAtCard" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                </th>
                <th>
                  {{ "Quot Name" | locale }}
                  <input nz-input [(ngModel)]="filters.quotName" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                </th>
                <th>
                  {{ "Date" | locale }}
                </th>
                <th>
                  {{ "Due Date" | locale }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let docRow of data.data; let  i = index">
                <td>
                  <nz-form-control class="check-box">
                    <label [ngModelOptions]="{standalone: true}" nz-checkbox [(ngModel)]="docRow.Selected"
                      [nzDisabled]="docRow.TreeType === 'I'"
                      (ngModelChange)="setChildChecked(documentSource.Id,docRow)"></label>
                  </nz-form-control>
                </td>
                <td>
                  {{ docRow.DocNum }}
                </td>
                <td>
                  {{ docRow.NumAtCard }}
                </td>
                <td>
                  {{ docRow.QuotName }}
                </td>
                <td>
                  {{ docRow.DocDate }}
                </td>
                <td>
                  {{ docRow.DocDueDate }}
                </td>
              </tr>
            </tbody>
          </nz-table>
        </form>
      </nz-tab>
    </nz-tabset>
  </form>
</nz-drawer>
<ng-template #copyFromDrawerFooter>
  <nz-space>
    <nz-space-item *ngIf="loading === false">
      <button [nzLoading]="loading" nz-button nzType="primary" (click)="addSelectedRows()">
        {{ "Submit" | locale }}
      </button>
    </nz-space-item>
    <nz-space-item>
      <button nz-button (click)="showCopyFromDrawer = false">
        {{ "Cancel" | locale }}
      </button>
    </nz-space-item>
  </nz-space>
</ng-template>
